import React, { useState } from 'react';
import { createSuscrito } from '../../actions/home';

export const GiftSm = () => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(email)) {
            setError('Por favor, introduce un correo electrónico válido.')
        } else {
            setError('')
            // console.log('Correo enviado:', email)
            try {
                const response = await createSuscrito(email, 'campania')
                console.log('Suscrito creado:', response);
                setEmail('')
            } catch (error) {
                console.error('Error al crear suscrito:', error);
                setError('Error al crear el suscrito. Inténtalo nuevamente.');
            }
        }
    }

    return (
        <div className='banner-gifts-sm position-relative'>
            <img
                src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=envio-gratis-sm.png&version_id=null"
                alt=""
                className="img-responsive"
            />

            <form className='input-gifs-sm position-absolute' onSubmit={handleSubmit}>
                <input 
                    type='email' 
                    placeholder='Ingresa tu correo electrónico' 
                    className='input-frm font-family-montserrat gift-input-sm'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" 
                />
                {/* <button type="submit">Enviar</button> */}
                {error && <div className='error-message'>{error}</div>} 
            </form>
        </div>
    );
};